module.exports = __webpack_public_path__ + "img/zf.b6eb0e63.png";